import { canonicalCountryName, sortedCountries } from '@/shared/countries';

const CountrySelect = ({
  value,
  onChange,
  onBlur,
  id,
  name,
  className = 'form-select',
  required = false,
  disabled = false,
  placeholder = 'Select country',
  isInvalid = false,
}) => {
  const stored = value == null ? '' : String(value);
  const options = sortedCountries();
  const selected = canonicalCountryName(stored) || stored;
  const known = options.some((country) => country.name === selected);

  return (
    <select
      id={id}
      name={name}
      className={`${className}${isInvalid ? ' is-invalid' : ''}`}
      value={selected}
      required={required}
      disabled={disabled}
      onBlur={onBlur}
      onChange={(event) => onChange?.(event.target.value)}
    >
      <option value="">{placeholder}</option>
      {stored && !known ? <option value={stored}>{stored}</option> : null}
      {options.map((country) => (
        <option key={country.code} value={country.name}>{country.name}</option>
      ))}
    </select>
  );
};

export default CountrySelect;
